/**
 * InfinitSales - Contact Journey Service
 * Read-only access to a contact's label-change history (PR-B).
 * Powers ContactJourneyLogs and ContactJourneyGraph.
 */
import api from './api';

class ContactJourneyService {
  /**
   * Get up to `limit` label change events for a contact, newest first.
   * @param {string} phone
   * @param {number} limit
   */
  async getLabelHistory(phone, limit = 200) {
    const encoded = encodeURIComponent(phone);
    const response = await api.get(
      `/api/contacts/${encoded}/label-history`,
      { params: { limit } }
    );
    return response.data;
  }
}

const contactJourneyService = new ContactJourneyService();
export default contactJourneyService;
